// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"477":"FaceDetection","636":"svgView","767":"FaceLiveness","785":"FaceResidentCamera","855":"FaceComparison","923":"FaceVerify"}[chunkId] || chunkId) + "." + {"477":"a5de81ca","636":"1703007c","767":"3237598f","785":"18eb236e","818":"032fa545","855":"e696e102","923":"11a05f58"}[chunkId] + ".css";
};